import { render } from "./Portfolio.vue?vue&type=template&id=2c24c32b"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=2c24c32b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__